module.exports = __webpack_public_path__ + "static/img/no-data.d3d781e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-data.png
// module id = dotK
// module chunks = 1